import { AREA_LABELS, type LeadValues } from "../../shared/lead";

/**
 * The Bond intake body. Name and phone are always present; the four optional values are omitted
 * when the visitor left them blank, so the API never receives an empty required attribute.
 */
export interface LeadPayload {
  name: string;
  phone: string;
  email?: string;
  company?: string;
  notes?: string;
  wanted_area?: string;
}

export function buildLeadPayload(values: LeadValues): LeadPayload {
  const payload: LeadPayload = {
    name: values.fullName,
    phone: values.phoneE164,
  };
  if (values.email !== "") payload.email = values.email;
  if (values.company !== "") payload.company = values.company;
  if (values.notes !== "") payload.notes = values.notes;
  if (values.area !== "") payload.wanted_area = AREA_LABELS[values.area];
  return payload;
}
